import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { baseHeaders } from 'util/axios-request';
import ueditor from '_c/ueditor';
var baseURL = process.env.VUE_APP_BASE_API;
export default {
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {
          title: '',
          content: ''
        };
      }
    }
  },
  components: {
    ueditor: ueditor
  },
  data: function data() {
    return {
      baseHeaders: baseHeaders(),
      fileFormat: ['.pdf'],
      action: baseURL + 'web/tool/upload_file',
      multiple: true,
      fileLimit: 1,
      rules: {
        title: [{
          required: true,
          message: this.$t('i18n.ce8221bbeb744a07b79b8956dd1a76cc')
        }],
        content: [{
          required: true,
          message: this.$t('629')
        }]
      },
      formData: {},
      data: {},
      // 标题 内容
      form: {
        title: this.$t('i18n.cc2205ac932a4b34b31ec3ef16fbd452'),
        content: '',
        file: [],
        p_type: '1'
      },
      loading: false
    };
  },
  mounted: function mounted() {
    this.form = JSON.parse(JSON.stringify(this.content));
    this.form.p_type = this.form.p_type || '1';
  },
  methods: {
    beforeUploadHandle: function beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        var fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(this.$t('729', {
            fileFormat: this.fileFormat.join()
          }));
          return false;
        }
      }

      // 文件大小
      // if (!(file.size / 1024 / 1024 < this.fileSize)) {
      //   this.$message.error(
      //     this.$t('730', {
      //       fileSize: this.fileSize
      //     })
      //   )
      //   return false
      // }
    },
    handleType: function handleType(val) {
      if (val === '1') {
        this.form.file = [];
        this.form.file_url = '';
        this.$refs.upload.uploadFiles = [];
      } else {
        this.$refs.ueditor.clearHtml();
        this.form.content = '';
      }
    },
    successHandle: function successHandle(res) {
      var list = this.$refs.upload.uploadFiles;
      this.$refs.upload.uploadFiles = [list[list.length - 1]];
      this.form.file_url = res.data.object_url;
    },
    handleError: function handleError(err) {
      this.$message.error('upload error');
      throw err;
    },
    beforeRemove: function beforeRemove() {
      return this.$confirm(this.$t('18'), this.$t('19'), {
        confirmButtonText: this.$t('20'),
        cancelButtonText: this.$t('21'),
        type: 'warning'
      });
    },
    // 删除
    handleRemove: function handleRemove(e, item) {
      this.form.file.splice(this.form.file.findIndex(function (v) {
        return v.object_url === item.object_url;
      }), 1);
      this.$refs.upload.uploadFiles.splice(this.$refs.upload.uploadFiles.findIndex(function (v) {
        return v.name === item.file_name;
      }), 1);
    }
  }
};